import { useApiClient } from '@m43/core';
import { DexActivityTabResource } from '@mark43/cad-api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export function useEventDexActivityQuery(props: {
    eventId?: number;
    queryOptions?: UseQueryOptions;
}) {
    const apiClient = useApiClient();
    return useQuery(
        ['dex-activity', props.eventId],
        () => {
            return apiClient
                .request<DexActivityTabResource.GetDexActivityTab>({
                    method: 'POST',
                    url: `dex_activity_tab`,
                    data: {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        eventId: props.eventId!,
                    },
                })
                .then((resp) => resp.data.data);
        },
        { refetchInterval: 5000, enabled: props.queryOptions?.enabled }
    );
}
